export const currentAssemblySelector = state => state.navigation.assembly;
export const currentDistributionSelector = state => state.navigation.distribution;
export const activeLinkSelector = state => state.navigation.activeLink;
